import ModuleWrapper from 'shared-lib/containers/Module';

const Banners = () => import(/* webpackChunkName: "banners" */ '@/views/banners/Banners');
const meta = (data = {}) => ({
    permissionsModuleName: 'banners',
    auth: true,
    ...data,
});

export default [{
    path: 'creatives',
    component: ModuleWrapper,
    meta: meta({
        permission: 'list',
        title: 'Creatives',
    }),
    children: [
        {
            path: '',
            name: 'Creatives',
            component: Banners,
            meta: meta({
                permission: 'list',
            }),
        },
    ],
}];
